import React from "react";
import { Link, useLocation } from "react-router-dom";
import GlobalSidebarMenu from "../../default/header/globalSidebarMenu";


const SingleSidebarMenu = () => {
    const location = useLocation();
    const isActive = (path, exact = false) => {
      if (exact) {
          return location.pathname === path ? 'active-menu' : '';
      } else {
          return location.pathname.startsWith(path) || location.pathname === path
              ? 'active-menu'
              : '';
      }
  };
    return (
        <div className="card-menu-wrapper">
            <div className="sticky-area has-top-level-menu">
                <div className="top-level-menu">
                    <GlobalSidebarMenu sidebarTitle=" "/>
                </div>
                <ul>
                    <li>
                        <Link className={isActive('/business/single', true)} to="/business/single">Profile</Link>
                    </li>
                    <li>
                        <Link className={isActive('/business/single/mockup')} to="/business/single/mockup">Mockup</Link>
                    </li>
                </ul>
            </div>
        </div>
    );
}

export default SingleSidebarMenu;
